module.exports = "<div class=\"table-column-container\">\r\n  <app-services-row></app-services-row>\r\n  <app-table></app-table>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/table-column/table-column.component.html
// module id = ./src/app/components/table-column/table-column.component.html
// module chunks = main